<div class="dialog-wrapper">
  <app-not-available-overlay>
    <div class="c-dialog-content pb-unset">
      <div class="chat-and-status-history-wrapper">
        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <app-order-status-block></app-order-status-block>
            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-07, 09:01</span>
            </div>
            <div class="message">
              <div class="upper-section">
                Buyer has initiated a return request. @if (true) {
                <div class="mt-4-px">Comment: Not a valid request</div>
                }
              </div>
              <app-uploaded-images-list
                [medium]="true"
                [deleteAction]="false"
              ></app-uploaded-images-list>
            </div>
          </div>
        </div>

        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <div class="chat-box">
              <img
                src="./../../../../assets/images/dialogs/chat/comment.svg"
                alt="chat-bubble"
              />
            </div>

            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-08, 15:00</span>
            </div>
            <div class="message">
              <div class="upper-section">Can you please still accept?</div>
            </div>
          </div>
        </div>

        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <app-order-status-block></app-order-status-block>
            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-07, 09:01</span>
            </div>
            <div class="message">
              <div class="upper-section">Buyer has received an item</div>
            </div>
          </div>
        </div>

        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <app-order-status-block></app-order-status-block>
            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-07, 09:01</span>
            </div>
            <div class="message">
              <div class="upper-section">Buyer has received an item</div>
              <app-uploaded-images-list
                [medium]="true"
                [deleteAction]="false"
              ></app-uploaded-images-list>
            </div>
          </div>
        </div>

        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <app-order-status-block></app-order-status-block>
            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-07, 09:01</span>
            </div>
            <div class="message">
              <div class="upper-section">
                Buyer has initiated a return request. @if (true) {
                <div class="mt-4-px">Comment: Not a valid request</div>
                }
              </div>
              <app-uploaded-images-list
                [medium]="true"
                [deleteAction]="false"
              ></app-uploaded-images-list>
            </div>
          </div>
        </div>

        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <div class="chat-box">
              <img
                src="./../../../../assets/images/dialogs/chat/comment.svg"
                alt="chat-bubble"
              />
            </div>

            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-08, 15:00</span>
            </div>
            <div class="message">
              <div class="upper-section">Can you please still accept?</div>
            </div>
          </div>
        </div>

        <div class="message-box-wrapper">
          <div class="message-status-box">
            @if (true) {
            <app-order-status-block></app-order-status-block>
            }
          </div>
          <div class="message-content">
            <div class="author-and-date-block">
              <span class="author">Buyer</span>
              <span class="date">2023-10-07, 09:01</span>
            </div>
            <div class="message">
              <div class="upper-section">Buyer has received an item</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-not-available-overlay>
  <div class="c-dialog-actions chat-footer">
    <div class="upper-section w-100">
      <app-upload-images [smallAction]="true"></app-upload-images>

      <div class="message-input w-100">
        <app-inline-input-control
          [classess]="'mb-unset no-label'"
          [type]="'text'"
          [sendMessageIconSuffix]="true"
          [control]="messageControl"
          [placeholder]="'Write message'"
          [name]="'message'"
        ></app-inline-input-control>
      </div>
    </div>
    <div class="w-100">
      <app-uploaded-images-list></app-uploaded-images-list>
    </div>
  </div>
</div>
